import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage, useIntl } from 'react-intl'
import {
    Swiper, SwiperSlide
} from 'swiper/react'
import { useWebp } from '../../../../../../hooks/common'
import { IMAGE_GEEKO_LTD } from '../../../../../../../constants'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { unitPrice } from '../../../../../../../utils/product'
import { getSensorsUrl } from '../../../../../../utils/sensor'
import { useHistory } from 'react-router-dom'
import BottomToTop from '../../../../../../components/transitions/bottom-to-top'
import { useState } from 'react'
import { withCartIcon } from '../../../../../listing/components/cart/cart-icon'
import Item from '../../../../fragments/item/element'
import { RowProducts } from '../../../../../listing/components/list'
import { BlackMask } from '../../../../../../components/mask'
import withSource from '../../../../../../hocs/source-scoll'
import withSourceClick from '../../../../../../hocs/source-only-click'
import Checkbox from '../../../../components/checkbox'


const GiftPickList = props => {
    useStyles(classes)
    const { giftRegionalCase, onClose } = props
    return (
        <div className={classes.GiftPickList}>
            <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
            <div className={classes.Title}>
            <span><FormattedMessage id="free_gifts" defaultMessage={'Free Gifts'} /></span>
                {
                    giftRegionalCase?.warnMsg && <span className={classes.TitleTip}>
                        {giftRegionalCase?.warnMsg}
                    </span>
                }
            </div>
            <div className={classes.GiftsList}>
                <RowProducts products={giftRegionalCase?.giftSelectList} isGift giftInfo={{
                    warnMsg: giftRegionalCase?.warnMsg
                }} />
            </div>
        </div>
    )
}

const GiftPickListMask = props => {
    useStyles(classes)
    const { onClose, show } = props

    return <>
        <BottomToTop in={show} className={classes.GiftTransitionBox}>
            <div>
                <GiftPickList {...props} />
            </div>
        </BottomToTop>
        {
            show && <BlackMask style={{ zIndex: 4 }} onClick={onClose} />
        }
    </>
}


const Head = withSource(props => {
    useStyles(classes)
    const history = useHistory()
    const {
        title,
        message,
        canBuyGift,
        showGiftPickList,
        gift,
        innerRef,
        goHandle,
        sensors,
        deepLink
    } = props

    return <div className={classes.Head}>
        <div className={classes.Title}>
            <span dangerouslySetInnerHTML={{ __html: message || title }} />
            {
                deepLink &&
                <React.Fragment>
                    {
                        (gift || canBuyGift) ? <span
                            ref={innerRef}
                            data-position={sensors.resource_position}
                            data-type={sensors.resource_type}
                            data-content={sensors.resource_content}
                            data-title={sensors.resourcepage_title}
                            className={classes.Pick} onClick={() => goHandle(canBuyGift ? 'gift' : 'products', sensors)}>
                                {
                                    canBuyGift ?
                                    gift ? <FormattedMessage id="repick" defaultMessage="Repick" /> : <FormattedMessage id="pick" defaultMessage="Pick" />:
                                    <FormattedMessage id="add" defaultMessage="Add" />
                                }
                            {
                                // gift ? <FormattedMessage id="repick" defaultMessage="Repick" /> : <FormattedMessage id="pick" defaultMessage="Pick" />
                            }
                            {'>'}
                        </span> : <span
                            ref={innerRef}
                            data-position={sensors.resource_position}
                            data-type={sensors.resource_type}
                            data-content={sensors.resource_content}
                            data-title={sensors.resourcepage_title}
                            className={classes.Add} onClick={() => goHandle('products', sensors)}>
                            <FormattedMessage id="add" defaultMessage="Add" />{'>'}
                        </span>
                    }
                </React.Fragment>
            }
        </div>
        {/* <div className={classes.Description}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
        </div> */}
    </div>
})

export const GiftItem = withSourceClick(props => {
    useStyles(classes)
    const { gift, onCart, warnMsg, canBuyGift, goHandle, sensors, innerRef, editing } = props
    const isWebp = useWebp()
    const imageUrl = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp' : ''}/medium/${gift.pcMainImage}`

    const history = useHistory();

    const clickHandle = e => {
        // if (canBuyGift) {
        //     onCart(e)
        // } else {
        //     Toast(warnMsg)
        // }
        // goHandle?.('products', sensors);
        // history.push(getSensorsUrl('/cart/collect-products', { ...sensors }))
        if(editing)return
        goHandle(canBuyGift ? 'gift' : 'products', sensors)
    }


    return <div 
        ref={innerRef} 
        className={classes.GiftItem} 
        onClick={clickHandle} 
        data-position={sensors?.resource_position}
        data-type={sensors?.resource_type}
        data-content={sensors?.resource_content}
        data-title={sensors?.resourcepage_title}
    >
        <div className={classes.Image}>
            <img src={imageUrl} />
            {/* <Iconfont className={classes.AddIcon}>
                &#xe6a8;
            </Iconfont> */}
        </div>
        <div className={classes.Price}>
            {
                unitPrice(gift.giftPrice)
            }
        </div>
    </div>
})

export const SwiperGifts = props => {
    useStyles(classes)
    const { gifts, canBuyGift, warnMsg, goHandle, sensors } = props
    // const sensors = {
    //     resourcepage_title: 'shoppingcart',
    //     resource_type: 'gifts',
    //     resource_content: 'Gifts',
    //     // resource_position: 4,
    //     column: 'gifts'
    // }
    return <Swiper slidesPerView="auto" className={classes.GiftList}>
        {
            gifts?.map((gift, index) => <SwiperSlide className={classes.SwiperSlide} key={index}>
                {/* 神策事件 */}
                <GiftItem canBuyGift={canBuyGift} warnMsg={warnMsg} gift={gift} productId={gift.id} isGift goHandle={goHandle} sensors={sensors} />
            </SwiperSlide>)
        }
    </Swiper>
}

export default props => {
    const { giftRegionalCase, itemDeleteHandle } = props
    const { title, canBuyGift, warnMsg, giftSelectList, gift, deepLink } = giftRegionalCase
    const [showGiftPickList, setShowGiftPickList] = useState(false);
    const history = useHistory();

    const sensors = {
        resourcepage_title: 'cart',
        resource_type: '6',
        resource_content: 'Gift',
        resource_position: 1,
    }

    const goHandle = (type, sensors) => {
        if (type === 'gift') {
            history.push(getSensorsUrl('/cart/free-gifts', { ...sensors }))
        } else {
            history.push(getSensorsUrl('/cart/collect-products', { ...sensors }))
        }
    }

    return <div className={classes.Container}>
        <Head title={title} message={warnMsg} gift={gift} deepLink={deepLink} canBuyGift={canBuyGift} showGiftPickList={setShowGiftPickList} goHandle={goHandle} sensors={sensors} />
        {
            gift ?
                <div className={`${classes.Bd} ${classes.GiftBd}`}>
                    {/* <SelectedGift gift={gift} canBuyGift={canBuyGift} {...props}/> */}

                    <Item item={gift} isGift canBuyGift={canBuyGift} itemDeleteHandle={itemDeleteHandle} />
                    {/* 礼物 */}
                </div> :
                <div className={classes.Bd}>
                    <SwiperGifts gifts={giftSelectList} warnMsg={warnMsg} canBuyGift={canBuyGift} sensors={sensors} goHandle={goHandle}/>
                </div>
        }
        <GiftPickListMask
            onClose={() => setShowGiftPickList(false)}
            show={showGiftPickList}
            giftRegionalCase={giftRegionalCase}
        />
    </div>
}

export const EditGift = (props) => {
    useStyles(classes)
    const { editing, selectedItems, itemSelectHandle, giftRegionalCase } = props

    const { gift, canBuyGift } = giftRegionalCase || {}
    const { canRemove } = gift || {}

    const clickHandle = e => {
        itemSelectHandle(gift)
    }

    let selected

    if (editing) {
        selected = selectedItems?.some(i => i.id === gift?.id)
    } else {
        selected = gift?.selected
    }

    return canRemove && <div className={classes.EditGiftBox}>
        <div className={classes.SelectableItem}>
            <div className={`${classes.SelectArea}`}>
                <Checkbox onClick={clickHandle} selected={selected} />
            </div>
            <div className={classes.ItemArea}>
                <Item item={gift} isGift editing canBuyGift={canBuyGift} {...props} />
            </div>
        </div>
    </div>
}